/*************************************************/
/* HEADER                                        */
/*************************************************/

export function menu() {
    const headerSelector = '.header';
    const parentMenuItemSelector = '.menu-nav__item--parent';
    const parentMenuItemParentSelector = '.menu-nav__item--parent';
    const parentMenuItemParentActiveClass = 'menu-nav__item--parent--active';
    const submenuSelector = '.mega-menu';
    const submenuHiddenClass = 'mega-menu--hidden';
    const headerWithActiveSubmenuClass = 'header--megamenu-active';
    const bodyWithActiveSubmenuClass = 'megamenu-active';
    const submenuItemParentSelector = '.mega-menu__item--parent';
    const submenuItemParentActiveClass = 'mega-menu__item--parent--active';
    const bannerWrapSelector = ".banner__wrap";
    const bannerWrapMegaMenuActiveClass = "banner__wrap--megamenu-active";

    const closeMegaMenu = () => {
        const megaMenus = document.querySelectorAll(submenuSelector);
        megaMenus.forEach(megaMenu => {
            megaMenu.setAttribute('aria-hidden', true);
            megaMenu.classList.add(submenuHiddenClass);
            megaMenu.closest(headerSelector).classList.remove(headerWithActiveSubmenuClass);
            megaMenu.closest(parentMenuItemParentSelector).classList.remove(parentMenuItemParentActiveClass);
            megaMenu.closest(bannerWrapSelector)?.classList.remove(bannerWrapMegaMenuActiveClass);
            document.body.classList.remove(bodyWithActiveSubmenuClass);
            

        });
    }

    const openMegaMenu = (megaMenu) => {
        megaMenu.setAttribute('aria-hidden', false);
        megaMenu.classList.remove(submenuHiddenClass);
        megaMenu.closest(headerSelector).classList.add(headerWithActiveSubmenuClass);
        megaMenu.closest(parentMenuItemParentSelector).classList.add(parentMenuItemParentActiveClass);
        megaMenu.closest(bannerWrapSelector)?.classList.add(bannerWrapMegaMenuActiveClass);
        document.body.classList.add(bodyWithActiveSubmenuClass);

    };

    const init = () => {
        const parentMenuItems = document.querySelectorAll(parentMenuItemSelector);
        if (parentMenuItems.length > 0) {
            parentMenuItems.forEach(item => {

                item.addEventListener('keypress', e => {
                    if (e.key === "Enter") {
                        item.click();
                    }
                });

                item.addEventListener('click', e => {
                    e.stopPropagation();
                    const megaMenu = item.closest(parentMenuItemParentSelector).querySelector(submenuSelector);
                    if (megaMenu) {
                        openMegaMenu(megaMenu);
                    }
                });

            });
        }

        const submenuParentItems = document.querySelectorAll(submenuItemParentSelector);
        if (submenuParentItems) {
            submenuParentItems.forEach(parentItem => {
                const link = parentItem.querySelector('a');

                link.addEventListener('keypress', e => {
                    if (e.key === "Enter") {
                        link.click();
                    }
                });

                link.addEventListener('click', e => {
                    parentItem.classList.toggle(submenuItemParentActiveClass);
                });
            })
        }

        document.addEventListener('click', () => {
            closeMegaMenu();
        });

        // Close mega menu if screen width gets under the breakpoint
        var mediaQuery = window.matchMedia("(max-width: 992px)");
        mediaQuery.addEventListener("change", function() {
            closeMegaMenu();
        }); 
    };

    init();

}

